
import {Component, Prop} from 'nuxt-property-decorator';
import Vue from 'vue';
import {shopsStore} from '~/lib/accessors/store-accessor';
import ChildView from '~/lib/types/ChildView';
import {ShopView, toShopView} from '~/lib/types/ShopView';
import appConfig from '~/lib/util/appConfig';
import {castToHtmlElement} from '~/lib/util/util';
import {Debounce} from '~/lib/util/vue-debounce-decorator';
import window_size_aware_mixin from '~/lib/util/window_size_aware_mixin';


@Component({
  mixins: [window_size_aware_mixin],
})
export default class ShopGrid extends Vue {
  // If child is undefined then we need to choose a child before redirecting to the shop.
  @Prop({
    type: Object,
    required: false,
  })
  child: ChildView | undefined

  style     = ''
  scrolling = false

  // Prevent auto scrolling on first page load
  autoScrollEnabled = false

  get shops(): ShopView[] {
    return shopsStore.items.map(shop => {
      return toShopView(shop, this.child, 'www');
    });
  }

  get hasNextPage() {
    return shopsStore.hasNextPage;
  }

  get defaultImage() {
    return appConfig.shopDefaultLogoUrl
  }

  mounted() {
    // @ts-ignore
    if (!this.$isMobile && ! this.windowSize.has('xs')) {
      this.$on('setMaxHeight', async (maxHeight: number) => {
        this.style = `max-height: ${maxHeight}px`;
      });
    }
  }

  loadMore() {
    this.autoScrollEnabled = true;
    this.$emit('loadMore')
  }

  scrollToBottom() {
    const $box = castToHtmlElement(this.$refs.shopsBox);
    if ($box) {
      this.$nextTick(() => {
        $box.scrollTo({
          top: $box.scrollHeight,
        })
      })
    }
  }

  @Debounce(250)
  onImageLoad(shopId: string) {
    if(this.autoScrollEnabled) {
      this.scrollToBottom();
    }
  }
}
